import { render, staticRenderFns } from "./OfferCarousel.vue?vue&type=template&id=e48faf24&scoped=true&"
import script from "./OfferCarousel.vue?vue&type=script&lang=js&"
export * from "./OfferCarousel.vue?vue&type=script&lang=js&"
import style0 from "./OfferCarousel.vue?vue&type=style&index=0&id=e48faf24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48faf24",
  null
  
)

export default component.exports